import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

const apiFetchRfidFileUpload = (payload) => {
  const formData = new window.FormData();

  formData.append('file', payload.file);
  formData.append('json', new window.Blob([payload.json], { type: 'application/json' }));

  const serviceUrl = constructServiceURL({
    endpoint: 'uploadRfidFile',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.post(serviceUrl, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export default apiFetchRfidFileUpload;
